var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 169,
  height: 144,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "Error_svg__a",
  width: 125,
  height: 110,
  x: 22,
  y: 17,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M146.617 17.223H22.664v109.553h123.953z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Error_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B26E3D",
  d: "M77.09 66.573a2.42 2.42 0 0 1-1.653-.65l-5.29-4.93a2.43 2.43 0 0 1-.122-3.43 2.424 2.424 0 0 1 3.427-.123l5.29 4.93a2.429 2.429 0 0 1-1.653 4.203M134.899 115.329a2.425 2.425 0 0 1-2.403-2.128l-.813-6.549a2.425 2.425 0 1 1 4.813-.598l.812 6.548a2.425 2.425 0 0 1-2.409 2.727"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "m116.118 111.909 1.078 10.826h11.921l-2.204-22.121-.019-.197-.033-.196a11.15 11.15 0 0 0-11.025-9.334c-5.932 0-10.835 4.644-11.161 10.574v.041l-.878 21.235h11.874l.447-10.826z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ABABAB",
  d: "M134.087 110.805a4.45 4.45 0 0 1-4.448-4.437c-.027-7.084-.479-11.927-1.419-15.24-.812-2.861-1.954-4.593-3.683-7.216l-.359-.546c-1.163-1.769-2.267-2.934-3.195-3.37-.573-.27-1.144-.282-2.186-.279h-.208a4.45 4.45 0 0 1-4.448-4.452 4.45 4.45 0 0 1 4.448-4.452h.194c1.425-.003 3.581-.007 5.985 1.124 2.482 1.168 4.721 3.306 6.845 6.535l.353.537c4.276 6.487 6.509 10.647 6.574 27.326a4.45 4.45 0 0 1-4.432 4.47h-.021"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ABABAB",
  d: "M116.909 96.07a5.333 5.333 0 0 0 5.331-5.336 5.334 5.334 0 0 0-5.331-5.336 5.334 5.334 0 0 0-5.331 5.336 5.333 5.333 0 0 0 5.331 5.336"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ABABAB",
  d: "M110.494 78.07a7.1 7.1 0 0 0 6.72 7.46c3.913.204 7.25-2.808 7.454-6.725.203-3.918-3.047-3.216-6.961-3.418-3.914-.204-7.011-1.235-7.213 2.682"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ABABAB",
  d: "m111.607 91.272 10.544.452 2.445-12.214-14.104-.74z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B26E3D",
  d: "M120.752 67.865a2.315 2.315 0 0 1-3.334.336 2.335 2.335 0 0 1-.375-3.104 2.31 2.31 0 0 1 3.302-.48 2.32 2.32 0 0 1 .827 2.38 2.3 2.3 0 0 1-.422.868z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M118.328 64.206c.142.345.406.974 1.11 1.964.341.478.9 1.239 1.382 1.614.172-.243.293-.506.36-.781a2.33 2.33 0 0 0-.829-2.386 2.3 2.3 0 0 0-1.372-.488q-.331-.007-.649.078z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M125.453 66.165a2.565 2.565 0 0 1-3.706.362 2.58 2.58 0 0 1-.493-3.3 2.56 2.56 0 0 1 3.747-.663 2.58 2.58 0 0 1 .918 2.637c-.083.34-.237.669-.466.964"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ABABAB",
  d: "M83.619 64.401c-.972-.74-1.564-1.237-1.602-1.267a4.45 4.45 0 0 0-6.27.525 4.455 4.455 0 0 0 .524 6.275c.138.118 1.668 1.404 3.982 3.044l1.886-.59 1.478-7.987zM117.828 70.813c-1.323 0-3.004.2-5.133.456-4.915.588-12.247 1.465-17.358-.143l-.15 9.14c2.454.5 5.021.683 7.539.683 4.036 0 7.941-.468 11.026-.837 1.689-.203 3.284-.393 4.076-.393a4.45 4.45 0 0 0 4.448-4.453 4.45 4.45 0 0 0-4.448-4.452z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00D639",
  d: "M140.777 126.776H98.343a5.844 5.844 0 0 1-5.835-5.84V59.203c0-3.22 2.618-5.84 5.835-5.84h42.436a5.844 5.844 0 0 1 5.835 5.84v61.733c0 3.22-2.617 5.84-5.835 5.84zM98.343 57.403c-.993 0-1.8.809-1.8 1.802v61.733c0 .993.807 1.802 1.8 1.802h42.436c.993 0 1.8-.809 1.8-1.802V59.203c0-.993-.807-1.801-1.8-1.801H98.343z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303030",
  d: "M135.996 114.498a.958.958 0 1 0-1.904.212l.89 8.026h1.93l-.913-8.236z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00D639",
  d: "M77.795 75.013H31.05c-4.625 0-8.386-3.767-8.386-8.394V34.901c0-4.629 3.763-8.393 8.386-8.393h46.745c4.624 0 8.386 3.766 8.386 8.393V66.62c0 4.63-3.763 8.394-8.386 8.394M31.05 30.548A4.357 4.357 0 0 0 26.7 34.9V66.62c0 2.4 1.952 4.354 4.35 4.354h46.745a4.357 4.357 0 0 0 4.35-4.354V34.901c0-2.4-1.952-4.353-4.35-4.353z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M49.81 59.832c-6.621-.742-11.405-6.738-10.664-13.364s6.732-11.415 13.353-10.674c6.62.742 11.404 6.739 10.663 13.365S56.431 60.574 49.81 59.831zm2.493-22.286c-5.657-.634-10.775 3.455-11.408 9.117s3.453 10.785 9.11 11.418c5.657.634 10.775-3.456 11.408-9.117.633-5.663-3.453-10.785-9.11-11.418"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M62.602 52.185a1.438 1.438 0 0 0-1.551 2.42l11.715 7.523a1.438 1.438 0 0 0 1.551-2.42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00D639",
  d: "M138.052 47.896h-36.248c-3.846 0-6.976-3.13-6.976-6.981v-16.71c0-3.85 3.129-6.982 6.976-6.982h36.248c3.845 0 6.975 3.13 6.975 6.981v16.71c0 3.85-3.128 6.982-6.975 6.982m-36.248-26.633a2.944 2.944 0 0 0-2.94 2.941v16.71a2.944 2.944 0 0 0 2.94 2.942h36.248c1.62 0 2.939-1.32 2.939-2.941v-16.71a2.944 2.944 0 0 0-2.939-2.942z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#919191",
  d: "M119.914 36.859h8.59v-8.597h-8.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ABABAB",
  d: "M111.32 36.859h8.59v-8.597h-8.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C6C6C6",
  d: "M102.734 36.859h8.59v-8.597h-8.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  d: "M128.5 36.859h8.59v-8.597h-8.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00D639",
  d: "M78.713 118.886H35.36a4.563 4.563 0 0 1-4.555-4.559V87.735a4.56 4.56 0 0 1 4.555-4.56h43.353a4.56 4.56 0 0 1 4.555 4.56v26.592a4.563 4.563 0 0 1-4.555 4.559M35.36 87.216a.52.52 0 0 0-.519.519v26.592c0 .287.232.519.519.519h43.353a.52.52 0 0 0 .519-.519V87.735a.52.52 0 0 0-.519-.52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5E5E5E",
  d: "M49.656 96.028v9.762l7.71 4.724V91.461zM63.879 108.422a.866.866 0 0 1-.7-1.372c.027-.038 1.966-2.775 2.037-6.218.072-3.449-1.803-6.32-1.82-6.35a.863.863 0 0 1 .241-1.196.86.86 0 0 1 1.196.239c.089.133 2.195 3.336 2.112 7.344-.083 4.006-2.273 7.069-2.367 7.196a.86.86 0 0 1-.7.357M61.05 105.925a.863.863 0 0 1-.754-1.283c.011-.02.877-1.617.918-3.626.041-2.014-.784-3.688-.792-3.704a.867.867 0 0 1 .383-1.16.86.86 0 0 1 1.158.38c.041.083 1.028 2.061.977 4.519s-1.091 4.35-1.134 4.43a.86.86 0 0 1-.756.444"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5E5E5E",
  d: "M66.801 111.319a.865.865 0 0 1-.676-1.404c.037-.046 3.08-3.94 3.18-8.846.103-4.91-2.843-8.991-2.871-9.033a.866.866 0 0 1 .184-1.208.86.86 0 0 1 1.206.183c.135.184 3.322 4.58 3.207 10.093-.114 5.513-3.417 9.712-3.557 9.889a.86.86 0 0 1-.676.324zM43.587 95.809h3.573v9.546h-3.573a2.08 2.08 0 0 1-2.08-2.081v-5.385c0-1.15.933-2.08 2.08-2.08"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B26E3D",
  d: "M72.828 62.324h-.05a.823.823 0 0 1-.77-.87c.035-.591.017-2.345-.48-3.375a.823.823 0 0 1 1.478-.716c.79 1.63.648 4.087.641 4.19a.82.82 0 0 1-.819.773z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B26E3D",
  d: "M74.43 63.64h-.051a.823.823 0 0 1-.77-.87c.035-.59.018-2.345-.48-3.375a.823.823 0 0 1 1.479-.716c.789 1.63.647 4.088.64 4.191a.82.82 0 0 1-.818.772z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B26E3D",
  d: "m75.518 61.392-2.466-.466-.24 2.004 1.347.282z"
}))));
export default SvgError;